<template>
  <div class="bpjs-page">
        <PageHeader icon="fas fa-mobile-alt">
      <template #title>
        Antrean Mobile JKN
      </template>
      <template #subtitle>
        Daftarkan pasien dan pantau status antrean BPJS secara real-time.
      </template>
      <template #actions>
        <button 
                type="button" 
                class="btn btn-primary font-weight-bold px-6 hc-btn-tambah-jadwal mt-4 mt-md-0"
                @click="openRegistrationForm"
              >
                <i class="fas fa-plus"></i><span>Daftar Antrean</span>
              </button>
      </template>
    </PageHeader>

    <div class="row">
      <div class="col-lg-5 mb-5">
        <b-card class="bpjs-card h-100 bpjs-form-card" title="Cek Status Booking">
          <b-form @submit.prevent="checkStatus">
            <b-form-group label="Kode booking">
              <b-form-input v-model.trim="bookingCode" required placeholder="Contoh: MED-20260725-001" class="bpjs-form-control" />
            </b-form-group>
            <b-button type="submit" variant="outline-success" block :disabled="loadingStatus" class="bpjs-control-button bpjs-outline-action">
              <b-spinner v-if="loadingStatus" small class="mr-2" /><i v-else class="fas fa-search mr-2"></i>Cek Status
            </b-button>
          </b-form>
        </b-card>
      </div>
      <div class="col-lg-7 mb-5">
        <b-card class="bpjs-card h-100" title="Informasi Antrean">
          <div v-if="statusData" class="bpjs-result-grid">
            <div v-for="item in statusDetails" :key="item.key" class="bpjs-result-item">
              <small>{{ item.label }}</small><strong>{{ item.value }}</strong>
            </div>
          </div>
          <div v-else class="bpjs-empty py-4">Masukkan kode booking untuk melihat progres pelayanan.</div>
        </b-card>
      </div>
    </div>

    <b-card class="bpjs-card bpjs-form-card">
      <b-form @submit.prevent="loadQueues">
        <div class="row align-items-end bpjs-filter-row">
          <div class="col-md-5 bpjs-filter-column">
            <b-form-group label="Tanggal" class="mb-0">
              <b-form-input v-model="filters.tanggal" type="date" class="bpjs-form-control" />
            </b-form-group>
          </div>
          <div class="col-md-4 bpjs-filter-column">
            <b-form-group label="Kode poli" class="mb-0">
              <b-form-input v-model.trim="filters.poliklinik" placeholder="Semua poli" class="bpjs-form-control" />
            </b-form-group>
          </div>
          <div class="col-md-3 bpjs-filter-column bpjs-action-column">
            <b-button type="submit" variant="outline-success" block class="bpjs-control-button bpjs-outline-action">
              <i class="fas fa-sync-alt mr-2"></i>Muat Antrean
            </b-button>
          </div>
        </div>
      </b-form>
      <div v-if="queues.length" class="table-responsive mt-4">
        <table class="table bpjs-table">
          <thead><tr><th>Kode Booking</th><th>No. Antrean</th><th>Poli</th><th>Pasien</th><th>Status</th><th class="bpjs-action-heading">Aksi</th></tr></thead>
          <tbody>
            <tr v-for="(queue, index) in queues" :key="queue.kodebooking || index">
              <td>{{ display(queue.kodebooking) }}</td><td>{{ display(queue.nomorantrean) }}</td>
              <td>{{ display(queue.namapoli || queue.kodepoli) }}</td><td>{{ display(queue.nama || queue.nik) }}</td>
              <td><span class="badge badge-light-success">{{ display(queue.status || queue.taskid) }}</span></td>
              <td class="bpjs-action-cell">
                <b-button class="bpjs-call-button" @click="call(queue)">
                  <i class="fas fa-bullhorn" aria-hidden="true"></i>
                  <span>Panggil</span>
                </b-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="bpjs-empty">Belum ada antrean untuk filter ini.</div>
    </b-card>

    <b-modal
      v-model="showForm"
      title="Daftar Antrean Mobile JKN"
      size="lg"
      hide-footer
      modal-class="bpjs-queue-modal"
      @hidden="resetRegistrationForm"
    >
      <b-form @submit.prevent="save">
        <b-alert v-if="verifiedParticipant" show variant="success" class="mb-4">
          <div class="d-flex align-items-start">
            <i class="fas fa-check-circle mr-3 mt-1"></i>
            <div>
              <strong>{{ verifiedParticipant.nama }} terverifikasi aktif</strong>
              <div class="small mt-1">
                Nomor kartu {{ verifiedParticipant.noKartu || "-" }} dan identitas peserta telah dibawa dari Verifikasi Peserta.
                {{ selectedCandidate ? "Perjanjian yang sesuai sudah dipilih otomatis." : "Pilih perjanjian BPJS peserta untuk melanjutkan." }}
              </div>
            </div>
          </div>
        </b-alert>

        <b-form-group label="Pilih Perjanjian BPJS" label-for="bpjs-queue-appointment">
          <b-form-select
            id="bpjs-queue-appointment"
            v-model="selectedAppointmentId"
            :options="appointmentOptions"
            :disabled="loadingRegistrationData"
            class="bpjs-form-control"
          />
          <small class="form-text text-muted">
            Hanya perjanjian BPJS terverifikasi yang belum pernah didaftarkan yang ditampilkan.
          </small>
        </b-form-group>

        <div v-if="loadingRegistrationData" class="bpjs-lookup-state">
          <b-spinner small class="mr-2" />Menyiapkan data perjanjian dan referensi BPJS...
        </div>

        <b-alert
          v-else-if="!candidates.length"
          show
          variant="info"
          class="mb-0"
        >
          Belum ada perjanjian BPJS terverifikasi yang siap didaftarkan untuk hari ini atau besok.
        </b-alert>

        <b-alert
          v-else-if="verifiedParticipant && !selectedCandidate"
          show
          variant="warning"
        >
          Peserta sudah aktif, tetapi belum memiliki perjanjian BPJS terverifikasi untuk hari ini atau besok. Buat perjanjian terlebih dahulu, kemudian kembali ke Antrean JKN.
        </b-alert>

        <template v-if="selectedCandidate">
          <b-alert v-if="selectedCandidate.issues.length" show variant="warning">
            <strong>Data perjanjian belum lengkap:</strong>
            {{ selectedCandidate.issues.join(" · ") }}
          </b-alert>

          <div class="bpjs-queue-summary mb-5">
            <div class="bpjs-queue-summary__item">
              <small>Pasien</small>
              <strong>{{ selectedCandidate.patient.name }}</strong>
              <span>{{ selectedCandidate.patient.medical_record_number || "Nomor rekam medis belum ada" }}</span>
            </div>
            <div class="bpjs-queue-summary__item">
              <small>Nomor BPJS</small>
              <strong>{{ selectedCandidate.patient.bpjs_card_number }}</strong>
              <span>{{ selectedCandidate.patient.bpjs_status }}</span>
            </div>
            <div class="bpjs-queue-summary__item">
              <small>NIK dan Nomor HP</small>
              <strong>{{ selectedCandidate.patient.nik || "NIK belum ada" }}</strong>
              <span>{{ selectedCandidate.patient.phone || "Nomor HP belum ada" }}</span>
            </div>
            <div class="bpjs-queue-summary__item">
              <small>Jadwal Periksa</small>
              <strong>{{ formatDate(selectedCandidate.date) }}</strong>
              <span>Pukul {{ selectedCandidate.time }}</span>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <b-form-group label="Poli BPJS" label-for="bpjs-queue-polyclinic">
                <b-form-select
                  id="bpjs-queue-polyclinic"
                  v-model="form.kodepoli"
                  :options="polyclinicOptions"
                  :disabled="Boolean(selectedCandidate.polyclinic.bpjs_code)"
                  class="bpjs-form-control"
                  required
                />
                <small class="form-text text-muted">
                  Poli Medhop: {{ selectedCandidate.polyclinic.name || "Belum tersedia" }}
                </small>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <b-form-group label="Dokter BPJS" label-for="bpjs-queue-doctor">
                <b-form-select
                  id="bpjs-queue-doctor"
                  v-model="form.kodedokter"
                  :options="doctorOptions"
                  :disabled="Boolean(selectedCandidate.doctor.bpjs_code)"
                  class="bpjs-form-control"
                  required
                />
                <small class="form-text text-muted">
                  Dokter Medhop: {{ selectedCandidate.doctor.name || "Belum tersedia" }}
                </small>
              </b-form-group>
            </div>
          </div>

          <div class="bpjs-auto-note">
            <i class="fas fa-magic"></i>
            <span>Kode booking, identitas pasien, nomor rekam medis, tanggal, dan nama layanan akan diisi otomatis oleh sistem.</span>
          </div>
        </template>

        <div class="d-flex justify-content-end mt-3">
          <b-button variant="light" class="mr-3" @click="showForm = false">Batal</b-button>
          <b-button type="submit" variant="success" :disabled="!canRegister"><b-spinner v-if="saving" small class="mr-2" />Daftarkan</b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import ApiService from "@/core/services/api.service";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { unwrap, rowsFrom, errorMessage, displayValue, today } from "./bpjs.helpers";

export default {
  data: () => ({
    bookingCode: "",
    loadingStatus: false,
    saving: false,
    showForm: false,
    statusData: null,
    queues: [],
    candidates: [],
    references: { doctors: [], polyclinics: [] },
    selectedAppointmentId: "",
    verifiedParticipant: null,
    loadingRegistrationData: false,
    filters: { tanggal: today(), poliklinik: "" },
    form: { kodepoli: "", kodedokter: "" },
  }),
  computed: {
    selectedCandidate() {
      return this.candidates.find(item => String(item.id) === String(this.selectedAppointmentId)) || null;
    },
    appointmentOptions() {
      return [
        { value: "", text: this.loadingRegistrationData ? "Memuat perjanjian..." : "Pilih pasien dan jadwal perjanjian" },
        ...this.candidates.map(item => ({
          value: item.id,
          text: item.label,
        })),
      ];
    },
    polyclinicOptions() {
      return this.referenceOptions(
        this.references.polyclinics,
        ["kdPoli", "kode", "code"],
        ["nmPoli", "nama", "name"],
        "Pilih poli BPJS"
      );
    },
    doctorOptions() {
      return this.referenceOptions(
        this.references.doctors,
        ["kdDokter", "kode", "code"],
        ["nmDokter", "nama", "name"],
        "Pilih dokter BPJS"
      );
    },
    canRegister() {
      return Boolean(
        !this.saving
        && this.selectedCandidate
        && this.selectedCandidate.ready
        && this.form.kodepoli
        && this.form.kodedokter
      );
    },
    statusDetails() {
      if (!this.statusData || typeof this.statusData !== "object") return [];

      return Object.entries(this.statusData).map(([key, value]) => {
        if (String(key).toLowerCase() === "taskid") {
          return {
            key,
            label: "Tahap Pelayanan",
            value: this.taskDescription(value),
          };
        }
        return { key, label: this.label(key), value: this.display(value) };
      });
    },
  },
  watch: {
    selectedAppointmentId() {
      const candidate = this.selectedCandidate;
      this.form.kodepoli = candidate ? candidate.polyclinic.bpjs_code || "" : "";
      this.form.kodedokter = candidate ? candidate.doctor.bpjs_code || "" : "";
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "BPJS Kesehatan" }, { title: "Antrean JKN" }]);
    this.loadQueues();
    this.resumeVerifiedParticipant();
  },
  methods: {
    async checkStatus() {
      this.loadingStatus = true;
      try {
        const response = await ApiService.get(`bpjs/antrean/status/${encodeURIComponent(this.bookingCode)}`);
        if (response.status >= 400) throw response;
        this.statusData = unwrap(response);
      } catch (error) {
        this.$bvToast.toast(errorMessage(error), { title: "Status tidak ditemukan", variant: "danger", solid: true });
      } finally { this.loadingStatus = false; }
    },
    async loadQueues() {
      try {
        const query = new URLSearchParams(this.filters).toString();
        const response = await ApiService.get(`bpjs/antrean?${query}`);
        if (response.status >= 400) throw response;
        this.queues = rowsFrom(response);
      } catch (error) {
        this.$bvToast.toast(errorMessage(error, "Antrean belum dapat dimuat."), { title: "Gagal", variant: "danger", solid: true });
      }
    },
    async openRegistrationForm() {
      this.showForm = true;
      await this.loadRegistrationData();
    },
    async resumeVerifiedParticipant() {
      if (this.$route.query.from !== "participant") return;

      let transferred = null;
      try {
        transferred = JSON.parse(sessionStorage.getItem("medhop.bpjs.verifiedParticipant") || "null");
      } catch (error) {
        sessionStorage.removeItem("medhop.bpjs.verifiedParticipant");
      }
      if (!transferred || transferred.status !== "AKTIF") return;

      const verifiedAt = new Date(transferred.verifiedAt || 0).getTime();
      if (!verifiedAt || Date.now() - verifiedAt > 30 * 60 * 1000) {
        sessionStorage.removeItem("medhop.bpjs.verifiedParticipant");
        return;
      }

      this.verifiedParticipant = transferred;
      this.showForm = true;
      await this.loadRegistrationData();

      const normalize = value => String(value || "").replace(/\D/g, "");
      const match = this.candidates.find(candidate => {
        const patient = candidate.patient || {};
        return (transferred.noKartu && normalize(patient.bpjs_card_number) === normalize(transferred.noKartu))
          || (transferred.nik && normalize(patient.nik) === normalize(transferred.nik));
      });

      if (match) this.selectedAppointmentId = match.id;
    },
    async loadRegistrationData() {
      this.loadingRegistrationData = true;
      try {
        const participantQuery = this.verifiedParticipant
          ? `?${new URLSearchParams({
            card_number: this.verifiedParticipant.noKartu || "",
            nik: this.verifiedParticipant.nik || "",
          }).toString()}`
          : "";
        const [candidateResponse, referenceResponse] = await Promise.all([
          ApiService.get(`bpjs/antrean/candidates${participantQuery}`),
          ApiService.get("bpjs/references"),
        ]);
        if (candidateResponse.status >= 400) throw candidateResponse;
        if (referenceResponse.status >= 400) throw referenceResponse;
        this.candidates = candidateResponse.data.items || [];
        this.references = {
          doctors: referenceResponse.data.doctors || [],
          polyclinics: referenceResponse.data.polyclinics || [],
        };
      } catch (error) {
        this.candidates = [];
        this.references = { doctors: [], polyclinics: [] };
        this.$bvToast.toast(errorMessage(error, "Data perjanjian atau referensi BPJS belum dapat dimuat."), { title: "Gagal", variant: "danger", solid: true });
      } finally {
        this.loadingRegistrationData = false;
      }
    },
    async save() {
      if (!this.canRegister) return;
      this.saving = true;
      try {
        const response = await ApiService.post(
          `bpjs/antrean/from-appointment/${this.selectedCandidate.id}`,
          this.form
        );
        this.$bvToast.toast(response.data.message || "Antrean berhasil didaftarkan.", { title: "Berhasil", variant: "success", solid: true });
        if (response.data.booking && response.data.booking.kodebooking) {
          this.bookingCode = response.data.booking.kodebooking;
        }
        this.showForm = false;
        await this.loadQueues();
      } catch (error) {
        this.$bvToast.toast(errorMessage(error), { title: "Gagal", variant: "danger", solid: true });
      } finally { this.saving = false; }
    },
    resetRegistrationForm() {
      this.selectedAppointmentId = "";
      this.form = { kodepoli: "", kodedokter: "" };
      this.verifiedParticipant = null;
      sessionStorage.removeItem("medhop.bpjs.verifiedParticipant");
    },
    referenceOptions(items, codeKeys, nameKeys, placeholder) {
      const options = [{ value: "", text: placeholder }];
      items.forEach(item => {
        const codeKey = codeKeys.find(key => item[key] !== undefined && item[key] !== null && item[key] !== "");
        if (!codeKey) return;
        const nameKey = nameKeys.find(key => item[key] !== undefined && item[key] !== null && item[key] !== "");
        const code = String(item[codeKey]);
        const name = nameKey ? item[nameKey] : code;
        options.push({ value: code, text: `${name} (${code})` });
      });
      return options;
    },
    formatDate(value) {
      if (!value) return "-";
      const parts = value.split("-");
      return parts.length === 3 ? `${parts[2]}-${parts[1]}-${parts[0]}` : value;
    },
    async call(queue) {
      try {
        await ApiService.post("bpjs/antrean/panggil", { kodebooking: queue.kodebooking });
        this.$bvToast.toast("Panggilan antrean dikirim.", { title: "Berhasil", variant: "success", solid: true });
      } catch (error) {
        this.$bvToast.toast(errorMessage(error), { title: "Gagal", variant: "danger", solid: true });
      }
    },
    display: displayValue,
    taskDescription(value) {
      const descriptions = {
        1: "Menunggu pelayanan administrasi",
        2: "Sedang dilayani bagian administrasi",
        3: "Menunggu pemeriksaan poli",
        4: "Sedang dilayani dokter atau poli",
        5: "Menunggu pelayanan farmasi",
        6: "Obat sedang disiapkan farmasi",
        7: "Pelayanan farmasi selesai",
        99: "Antrean dibatalkan",
      };
      return descriptions[String(value)] || "Tahap pelayanan belum diketahui";
    },
    label(key) { return key.replace(/([A-Z])/g, " $1").replace(/_/g, " ").replace(/\b\w/g, char => char.toUpperCase()); },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .bpjs-queue-modal .modal-content {
  border: 0;
  border-radius: 16px;
  overflow: hidden;
}

.bpjs-lookup-state {
  min-height: 96px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
}

.bpjs-queue-summary {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.bpjs-queue-summary__item {
  min-width: 0;
  padding: 13px 14px;
  border: 1px solid #e4efed;
  border-radius: 11px;
  background: #f7fbfa;
}

.bpjs-queue-summary__item small,
.bpjs-queue-summary__item strong,
.bpjs-queue-summary__item span {
  display: block;
}

.bpjs-queue-summary__item small {
  margin-bottom: 4px;
  color: #718096;
  font-size: 11px;
}

.bpjs-queue-summary__item strong {
  color: #21364d;
  font-size: 13px;
  overflow-wrap: anywhere;
}

.bpjs-queue-summary__item span {
  margin-top: 2px;
  color: #64748b;
  font-size: 11px;
}

.bpjs-auto-note {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 11px 13px;
  border-radius: 10px;
  background: #edf8f6;
  color: #47716d;
  font-size: 11px;
}

.bpjs-auto-note i {
  color: #16867f !important;
}

.bpjs-action-heading,
.bpjs-action-cell {
  width: 118px;
  text-align: center;
}

.bpjs-call-button.btn {
  min-width: 88px;
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 13px;
  border: 1px solid #cfe1ea;
  border-radius: 10px;
  background: #fff;
  color: #08769a;
  box-shadow: 0 3px 10px rgba(31, 78, 121, 0.06);
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
}

.bpjs-call-button.btn:hover,
.bpjs-call-button.btn:focus {
  border-color: #8acfc9;
  background: #f4fbfa;
  color: #08769a;
}

.bpjs-call-button.btn i {
  position: static !important;
  margin: 0 !important;
  color: #15978f !important;
  font-size: 13px;
  line-height: 1;
}

@media (max-width: 575.98px) {
  .bpjs-queue-summary {
    grid-template-columns: 1fr;
  }
}
</style>
